import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-78ae050b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex flex-row w-full",
  style: {"height":"calc(100vh)"}
}
const _hoisted_2 = {
  class: "flex flex-col w-full px-4 pt-4 pb-0",
  style: {"height":"100vh"}
}
const _hoisted_3 = {
  class: "",
  style: {"height":"4rem"},
  id: "header"
}
const _hoisted_4 = {
  class: "flex flex-col w-full",
  style: {"height":"calc(100vh - 4rem)"}
}
const _hoisted_5 = { class: "relative w-full h-full" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute z-10 w-full h-full opacity-70" }, null, -1))
const _hoisted_7 = { class: "relative z-20 p-4" }
const _hoisted_8 = {
  class: "flex items-center",
  style: {"height":"3rem"},
  id: "footer"
}

import { useSidebar } from "@/composable/useSidebar";
	
export default /*#__PURE__*/_defineComponent({
  __name: 'WorkspaceLayout',
  setup(__props) {

	const { collapsed } = useSidebar();

return (_ctx: any,_cache: any) => {
  const _component_AppMenu = _resolveComponent("AppMenu")!
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['shrink-0 transition-all duration-300 ease-in-out', _unref(collapsed) ? 'w-[88px]' : 'w-[350px]']),
      id: "menu"
    }, [
      _createVNode(_component_AppMenu)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AppHeader)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_AppFooter)
        ])
      ])
    ])
  ]))
}
}

})